import React from 'react'
import { Link } from 'react-router'
import './PlateMandala.css'
import emptyCell from './empty-cell.svg'

const PlateMandalaComponent = (props) => {
  return (
    <div className="PlateCellComponent">
    <Link to={`${props.title}`}><img src={props.cellImageUrl} alt={props.title} width="91" height="91"/></Link>
    </div>
  )
}

export const PlateMandalaPlaceholderComponent = () => {   // ???: なぜあとから export できない？
  return <div className="PlateMandalaPlaceholder"><img src={emptyCell} alt="空のセル" /></div>
}

export default PlateMandalaComponent



/** WEBPACK FOOTER **
 ** ./src/components/PlateMandalaComponent.js
 **/